import React from 'react';
import { X, Check } from 'lucide-react';

const sectionIcons = {
  Structure: "🏗️",
  Kitchen: "🍳",
  Bathroom: "🚿",
  "Doors & Windows": "🚪",
  Plastering: "🧱",
  Painting: "🎨",
  Flooring: "🏠",
  Wiring: "⚡",
  Others: "📋"
};

export const PackageDetailModal = ({ pkg, onClose }) => {
  if (!pkg) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] flex flex-col animate-in zoom-in-95 duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex-shrink-0 bg-white border-b border-gray-200 rounded-t-2xl px-4 sm:px-6 py-4 sm:py-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl sm:text-3xl font-heading font-bold text-gray-900">
              {pkg.name}
            </h2>
            <p className="text-brand-600 text-xl sm:text-2xl font-bold mt-1">{pkg.price}</p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors duration-200 flex-shrink-0"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto flex-1 px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8">
          <p className="text-gray-600 text-base sm:text-lg mb-6 sm:mb-8">{pkg.description}</p>

          <div className="space-y-6 sm:space-y-8">
            {pkg.details.map((section) => (
              <div key={section.title} className="bg-gray-50 rounded-xl sm:rounded-2xl border border-gray-200 overflow-hidden">
                <div className="bg-white border-b border-gray-200 px-4 sm:px-6 py-3 sm:py-4">
                  <h3 className="text-base sm:text-lg font-bold text-gray-900">
                    {sectionIcons[section.title] || "📌"} {section.title}
                  </h3>
                </div>
                <div className="p-4 sm:p-6">
                  <table className="w-full">
                    <tbody>
                      {section.items.map((item, i) => (
                        <tr key={i} className={`${i < section.items.length - 1 ? 'border-b border-gray-200' : ''}`}>
                          <td className="py-2.5 sm:py-3 pr-4 sm:pr-6 align-top">
                            <span className="text-xs sm:text-sm font-medium text-gray-900 whitespace-nowrap">
                              {item.label}
                            </span>
                          </td>
                          <td className="py-2.5 sm:py-3 align-top">
                            <span className="text-xs sm:text-sm text-gray-600">{item.value}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 sm:mt-8 p-4 sm:p-6 bg-brand-50 rounded-xl sm:rounded-2xl border border-brand-100">
            <p className="text-xs sm:text-sm text-brand-800 leading-relaxed">
              <strong>Note:</strong> All specifications are subject to change based on site conditions and material availability at the time of construction. All packages are fully customizable to your specific needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
